const onRun = () => {
    // QnA
    const qnaToggle = document.querySelectorAll(".js-qna-toggle");
    if (qnaToggle) {
        qnaToggle.forEach((item) => {
            item.addEventListener('click', function () {
                this.classList.toggle('is-open');
            });
        });
    }
};
if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

